export const PM_USERS_RESET_PASSWORD_OPEN_MODAL = "PM_USERS_RESET_PASSWORD_OPEN_MODAL";
export const PM_USERS_RESET_PASSWORD_CLOSE_MODAL = "PM_USERS_RESET_PASSWORD_CLOSE_MODAL";

export const PM_USERS_RESET_PASSWORD_REQUEST = "PM_USERS_RESET_PASSWORD_REQUEST";
export const PM_USERS_RESET_PASSWORD_RESULT = "PM_USERS_RESET_PASSWORD_RESULT";